
import mixins from '../../../../../../ManagementApp/wwwroot/client/src/helpers/utils/vueMixins.js';
export const crudMixinGen = mixins.crudMixinGen;
export const myCommonDataMixin = mixins.myCommonDataMixin;
export default mixins;